import React, { ComponentType } from 'react'
import { FormatStartDate } from '../utils/startDate'
import { formatTime, formatTimeWithZone } from '../utils/time'
import { Header } from '../Header/Header'

export interface EventSearchResultItem {
  title?: string
  permalink: string
  eventType?: string
  locationName?: string
  startDate?: string
  endDate?: string
  timeZone?: string
  image?: {
    poster?: string
  }
  RenderLink?: ComponentType<EventSearchResultItem>
}

export interface EventSearchResultProps {
  items: EventSearchResultItem[]
}

const RenderLinkDefault = ({
  title,
  permalink,
  startDate,
  locationName,
  endDate,
  timeZone
}: EventSearchResultItem) => {
  const date = (startDate && FormatStartDate(startDate, 'MMM dd, yyyy')) || ' '
  const dateString = `${date} | `
  const startTime = startDate && formatTime(startDate)
  const endTime = endDate && ` - ${formatTimeWithZone(endDate, timeZone)}`
  const ariaLabel = `${title} ${date} ${startTime} ${endTime} ${locationName}`

  return (
    <a href={permalink} aria-label={ariaLabel}>
      {title}
      <p>
        {`${dateString}`}
        {startTime}
        {endTime}
        <br />
        {locationName}
      </p>
    </a>
  )
}

export const EventSearchResult = ({ items }: EventSearchResultProps) => (
  <div className="column__main">
    <div className="column__three column--merge-a">
      {items.map((item) => {
        if (!item) return null
        const {
          image,
          permalink,
          title,
          locationName,
          startDate,
          endDate,
          timeZone,
          RenderLink = RenderLinkDefault
        } = item

        const background =
          image && image.poster
            ? {
                backgroundImage: `url(${image.poster}), var(--gradient-background)`
              }
            : {
                backgroundImage: `linear-gradient(90deg, rgba(75, 75, 107,1) 20.3254443900848%,rgba(74, 74, 106,1) 20.3254443900848%,rgba(47, 47, 66,1) 80.32625978473581%)`
              }

        return (
          <div className="column search__media" key={permalink}>
            <div className="bg--img bg--blend box box--4" style={background}>
              <Header level={4} className="heading--6 box--4">
                <RenderLink
                  permalink={permalink}
                  title={title}
                  startDate={startDate}
                  endDate={endDate}
                  locationName={locationName}
                  timeZone={timeZone}
                />
              </Header>
            </div>
          </div>
        )
      })}
    </div>
  </div>
)
